module.exports = __webpack_public_path__ + "static/media/map.fe2b198c.jpg";